import { IUser } from "@aptedge/lib-ui/src/types/entities";
import {
  GTM_EVENTS,
  dataLayerPushToGTM
} from "@aptedge/lib-ui/src/utils/event";
import { logger } from "@aptedge/lib-ui/src/utils/logger";
import { z } from "zod";

const USER_LOCAL_STORAGE_KEY = "ae_user";
const USER_SCHEMA = z.object({
  id: z.number(),
  email: z.string(),
  admin: z.boolean(),
  accountName: z.string(),
  onboardingComplete: z.boolean()
});

function fetchUserFromLocalStorage(): IUser | null {
  try {
    const userJson = localStorage.getItem(USER_LOCAL_STORAGE_KEY);

    if (userJson) {
      const userMetadata: IUser = JSON.parse(userJson);
      const result = USER_SCHEMA.safeParse(userMetadata);

      if (result.success) {
        return userMetadata;
      }
    }
  } catch (e) {
    logger.error("Unable to fetch user to local storage: " + e);
  }

  return null;
}

function saveUserToLocalStorage(user: IUser): void {
  try {
    const result = USER_SCHEMA.safeParse(user);

    if (result.success) {
      const validUser = result.data;
      localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(validUser));
      dataLayerPushToGTM({
        event: GTM_EVENTS.GTM_USER_CONTEXT,
        data: {
          user_email: validUser.email,
          account_name: validUser.accountName
        }
      });
    }
  } catch (e) {
    logger.error("Unable to save user to local storage: " + e);
  }
}

function deleteUserFromLocalStorage(): void {
  localStorage.removeItem(USER_LOCAL_STORAGE_KEY);
}

export {
  deleteUserFromLocalStorage,
  fetchUserFromLocalStorage,
  saveUserToLocalStorage
};
